export default __webpack_public_path__ + "static/media/search.2222923f.png";